<template>
  <DashboardPage>
    <AffiliateForm :id="route.params.id" />
  </DashboardPage>
</template>
  
<script setup>
import { useRoute } from 'vue-router';

import DashboardPage from '@/components/DashboardPage.vue'

import AffiliateForm from './components/AffiliateForm.vue';

const route = useRoute()

</script>